import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelFilterInterface } from 'modules/funnels/types/funnel-filter-interface';
import { FunnelApiInterface } from 'modules/funnels/types/funnel-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
interface UseFunnelsInterface extends SwrPaginationInterface {
  filter: FunnelFilterInterface;
}
export function useFunnels(t0) {
  const $ = _c(13);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.search !== "" ? `&filter[searchBy]=${encodeURIComponent(filter.search)}` : ""}${filter.status !== undefined ? `&filter[isActive]=${filter.status}` : ""}`;
  let t2;
  if ($[1] !== filterApi || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${FUNNELS_API}/list?pagination[limit]=${limit}${filterApi}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${FUNNELS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`;
        }
      }
      return null;
    };
    $[1] = filterApi;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: funnels,
    mutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[6] !== filterApi || $[7] !== user) {
    t3 = () => {
      if (user) {
        return `${FUNNELS_API}/count?pagination[limit]${filterApi}`;
      }
      return null;
    };
    $[6] = filterApi;
    $[7] = user;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: counter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[9] !== counter || $[10] !== funnels || $[11] !== mutate) {
    t4 = {
      funnels,
      mutate,
      counter
    };
    $[9] = counter;
    $[10] = funnels;
    $[11] = mutate;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}